import { format } from "date-fns";
import { useEffect } from "react";
import { Fragment } from "react/jsx-runtime";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { ButtonComponent } from "../../../../ui/molecules/button/newButton";
import { Calendar } from "../../../../ui/molecules/calendar";
import TextArea from "../../../../ui/molecules/textArea";
import { GetByIdPersonalManagement } from "../../slice";
import { RequirementDetailUpdate, RequirementDetailValidation, resetRequirementDetailErrors, resetRequirementDetails, resetRequirementDetailUpdateRequest, resetRequirementDetailUpdateStatus, resetRequirementDetailValidationStatus, setUpdateReqDetailDetail, setUpdateReqDetailEnding, setUpdateReqDetailNote, setUpdateReqDetailProtocols, setUpdateReqDetailStarting } from "../slice";

interface Props {
    close: () => void
}

export function RequirementDetailPopupEdit(props: Props) {
    const dispatch = useAppDispatch()
    const requirementState = useAppSelector(state => state.PMRequirement)
    const PMState = useAppSelector(state => state.personalManagement)

    useEffect(() => {
        if (requirementState.requirementDetailValidationStatus === 'successfully') {
            dispatch(resetRequirementDetailValidationStatus())
            dispatch(resetRequirementDetailErrors())
            dispatch(RequirementDetailUpdate({ body: requirementState.requirementDetailUpdateRequest, id: requirementState.requirementDetailIdToUpdate }))
        }
    }, [requirementState.requirementDetailValidationStatus])

    useEffect(() => {
        if (requirementState.requirementDetailUpdateStatus === 'successfully') {
            dispatch(resetRequirementDetailUpdateStatus())
            dispatch(resetRequirementDetailUpdateRequest())
            dispatch(resetRequirementDetails())
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId!))
            props.close()
        }
    }, [requirementState.requirementDetailUpdateStatus])

    return (
        <Fragment>
            <div className="bg-white p-6 flex flex-col gap-6">
                <div className="grid grid-cols-2 gap-6">
                    <Calendar
                        label="Dal"
                        selected={requirementState.requirementDetailUpdateRequest.starting}
                        onChange={(date) => {
                            dispatch(setUpdateReqDetailStarting(format(new Date(date), 'yyyy-MM-dd')))
                        }}
                    />
                    <Calendar
                        label="Al"
                        selected={requirementState.requirementDetailUpdateRequest.ending}
                        onClear={(date) => dispatch(setUpdateReqDetailEnding(date))}
                        onChange={(date) => {
                            dispatch(setUpdateReqDetailEnding(format(new Date(date), 'yyyy-MM-dd')))
                        }}
                    />
                </div>
                <TextArea
                    label="Dettagli requisito"
                    placeholder="Descrivi i dettagli del requisito"
                    value={requirementState.requirementDetailUpdateRequest.detail}
                    defaultValue={requirementState.requirementDetailUpdateRequest.detail}
                    error={requirementState.requirementDetailErrors.detail}
                    supportingText={requirementState.requirementDetailErrors.detail ? 'Dettagli mancanti!' : undefined}
                    onChangeText={(text) => dispatch(setUpdateReqDetailDetail(text))} />

                <TextArea
                    label="Specifiche protocollo"
                    placeholder="Specificare Sede, Data e Numero di Protocollo..."
                    value={requirementState.requirementDetailUpdateRequest.protocols}
                    defaultValue={requirementState.requirementDetailUpdateRequest.protocols}
                    error={requirementState.requirementDetailErrors.protocols}
                    supportingText={requirementState.requirementDetailErrors.protocols ? 'Dettagli mancanti!' : undefined}
                    onChangeText={(text) => dispatch(setUpdateReqDetailProtocols(text))} />

                <TextArea
                    label="Note"
                    value={requirementState.requirementDetailUpdateRequest.note}
                    defaultValue={requirementState.requirementDetailUpdateRequest.note}
                    onChangeText={(text) => dispatch(setUpdateReqDetailNote(text))} />
            </div>
            <div className="flex justify-end gap-2 border-t border-neutral-200 px-6 py-4 bg-neutral-50">
                <ButtonComponent
                    size="md"
                    variant="outline"
                    iconPosition="off"
                    label="Annulla"
                    color="gray"
                    onClick={() => {
                        dispatch(resetRequirementDetailUpdateRequest())
                        dispatch(resetRequirementDetailErrors())
                        props.close();
                    }}
                />
                <ButtonComponent
                    size="md"
                    variant="solid"
                    iconPosition="off"
                    label="Salva"
                    color="orange"
                    onClick={() => {
                        dispatch(RequirementDetailValidation(requirementState.requirementDetailUpdateRequest))
                    }}
                />
            </div>
        </Fragment>
    )
}